import Immutable from 'immutable';
import { UPDATE_ACTIVE_QUERY } from '../actions/header/autocomplete';

const AUTO_COMPLETE = 'autocomplete';
const ACTIVE_QUERY = 'activeQuery';

const NO_TEXT = '';

const initialState = Immutable.fromJS({
    activeQuery: {
        searchTerm: NO_TEXT,
    },
});

export const autocompleteActiveQuerySelector = (state) => state.getIn([AUTO_COMPLETE, ACTIVE_QUERY]);

function updateActiveQuery(state, payload) {
    const searchTerm = payload.query || '';
    const query = state.get(ACTIVE_QUERY, Immutable.Map());

    const newResults = query.merge({
        searchTerm,
    });

    return newResults;
}

export default function autocomplete(state = initialState, action = '') {
    switch (action.type) {
        case UPDATE_ACTIVE_QUERY:
            return state.set(ACTIVE_QUERY, updateActiveQuery(state, action.payload));

        default:
            return state;
    }
}
